import request from "@/api";

export function listBanner(data) {
    return request({
        url: '/api/banner/getBannerList',
        method: 'get',
        params: data
    })
}
export function saveBanner(data) {
    return request({
        url: '/api/banner/saveBanner',
        method: 'post',
        data: data
    })
}

export function getBannerInfo(data) {
    return request({
        url: '/api/banner/getBannerInfo',
        method: 'get',
        params: data
    })
}

export function deleteBanner(data) {
    return request({
        url: '/api/banner/deleteBanner',
        method: 'post',
        data: data
    })
}